import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatNumber } from '~/lib';
import { getFeatureAmount } from '~/pages/FeatureListing/utils';
import { ListingFeatureType } from '~/types/featureListingTypes';

export default function FeatureSummary({
  feature,
  changeUrl,
}: {
  feature: ListingFeatureType | null;
  changeUrl: string;
}) {
  const { t } = useTranslation('app');

  return (
    <div className="flex w-full flex-col gap-2x">
      <div className="flex w-full items-center justify-between gap-x">
        <p className="text-title-4 text-black">{feature?.title}</p>
        <Link to={changeUrl} className="text-link text-blue hover:underline">
          {t('change')}
        </Link>
      </div>
      <div className="flex w-full items-center justify-between gap-x">
        <p className="text-body_2 text-black">{t('featurePrice')}</p>
        <p className="text-body_2 text-black">
          <Trans
            i18nKey="priceValue"
            t={t}
            values={{ value: formatNumber(getFeatureAmount(feature)) }}
            components={{ tag: <span>placeholder</span> }}
          />
        </p>
      </div>
    </div>
  );
}
